module.exports = __webpack_public_path__ + "img/cat.58cd67b7.png";